import Typography from "@mui/material/Typography";
import { useLocation } from "react-router-dom";
import OriginsTable from "./OriginsTable";
import ExtractionTable from "./ExtractionTable";
import ReasonForTravelTable from "./ReasonForTravelTable";

export default function ExtractionPage() {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const surveyCode = params.get('survey');
    const mode = (params.get('mode') || '').toLowerCase();

    if (!surveyCode) return <Typography color="error">Missing ?survey= param.</Typography>;
    if (!mode) return <Typography color="error">Missing ?mode= param.</Typography>;
    if (mode === 'origins') return <OriginsTable surveyCode={surveyCode} />;
    if (mode === 'purpose') return <ReasonForTravelTable surveyCode={surveyCode} />;

    return <ExtractionTable surveyCode={surveyCode} />;
}